/**
 * Alias de nombres de producto para mostrar en el sitio Lovable
 * sin tocar los títulos en Shopify. Mapea por handle.
 *
 * Convención: "[Producto] personalizado/a con tu mascota"
 */

const TITLE_ALIASES: Record<string, string> = {
  "retrato-pop-digital": "Retrato pop digital personalizado con tu mascota",
  "retrato-digital-basico": "Retrato digital personalizado con tu mascota (24–48h)",
  "pawtrait-case": "Funda personalizada con tu mascota",
  "pawtrait-hoodie-over-size": "Hoodie personalizado con tu mascota",
  "pawtrait-playera-over-size": "Playera personalizada con tu mascota",
  "pawtrait-wallet": "Cartera personalizada con tu mascota",
  "pawtrait-termo-premium": "Termo personalizado con tu mascota (premium)",
  "pawtrait-termo-a": "Termo personalizado con tu mascota",
  "pawtrait-tote-pintado": "Tote personalizado con tu mascota",
  "pawtrait-25-stickers": "Stickers personalizados con tu mascota",
  // Bundles
  "bundle-mi-mascota-conmigo": "Bundle Mi mascota conmigo — Playera + Retrato digital",
  "bundle-regalo-perfecto": "Bundle Regalo perfecto — Playera + Stickers",
  "bundle-full-fan": "Bundle Full fan — Hoodie + Playera",
  "bundle-arte-hogar": "Bundle Arte + hogar — Canvas + Stickers",
  // Lienzos: "Lienzo pintado a mano (medida)"
};

/**
 * Normaliza el título del producto para mostrar en UI.
 * Reglas:
 *  1. Si hay alias por handle, úsalo.
 *  2. Si es un lienzo (handle empieza con "pawtrait-lienzo-" o título incluye "Lienzo"),
 *     devuelve "Lienzo pintado a mano (medida)" extrayendo la medida.
 *  3. Si el título empieza con "PAWTRAIT " o "PAWTRAiT ", lo limpia.
 *  4. Fallback: título original.
 */
export function getDisplayTitle(handle: string, originalTitle: string): string {
  if (TITLE_ALIASES[handle]) return TITLE_ALIASES[handle];

  const lowerTitle = originalTitle.toLowerCase();
  const lowerHandle = handle.toLowerCase();

  // Lienzos: extraer medida (ej "10x10 cm", "90x120 cm")
  if (lowerHandle.includes("lienzo") || lowerTitle.includes("lienzo")) {
    const sizeMatch = originalTitle.match(/(\d+\s*x\s*\d+\s*cm)/i);
    const size = sizeMatch ? sizeMatch[1] : "";
    return size ? `Lienzo pintado a mano (${size})` : "Lienzo pintado a mano";
  }

  // Limpieza genérica del prefijo de marca
  return originalTitle
    .replace(/^PAWTRAi?T\s+/i, "")
    .trim() || originalTitle;
}
